import React, { useEffect, useState } from "react";
import { LoginInputs } from "../../../../Components/LoginInputs";
import { SignIn } from "../../../../Components/SignIn";
import { InputContainer, InputButton, HelperSpan } from "./styles";
import { SignInButton } from "../../../../Components/Buttons/SingnInButton";
import { RememberPassword } from "../../../../Components/RememberPassword";
import { useCartorio } from "../../../../Hooks/cartorio";
import { validateCPF } from "../../../../Services/validateCPF";
import { cpfMask } from "../../../../Services/cpfMask";
import { limpa_cpf_cnpj } from "../../../../Services/limpa_cpf_cnpj";
import { Alert } from "../../../../Components/Error/Alert";
import { cartorioKey } from "../../../../Utils/localStorageKeys";
import api from "../../../../Services/api";
import { ListFuncionariosModal } from "../../../../Components/ListFuncionariosModal";
import { IFuncionarioCartorioList } from "../../../../Hooks/funcionarioCartorio";

export function SignFuncionarioPrefeitura() {
  const [cpf_cnpj, setCpfCnpj] = useState("");
  const [senha, setSenha] = useState("");
  const [error, setError] = useState("");
  const [errorTitle, setErrorTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [openModalList, setOpenModalList] = useState(false);
  const[funcionariosByCpfList, setFuncionariosByCpfList] = useState({} as IFuncionarioCartorioList[])

  const {  cartorio } = useCartorio();

  function handleCPF_CNPJ(cpf_cnpj: string) {
    setCpfCnpj(cpf_cnpj);

    setCpfCnpj(cpfMask(cpf_cnpj));
  }

  function handleSenha(pass: string) {
    setSenha(pass.trim());
  }

  async function handleSignIn() {
    setLoading(true);

    const cpf_cnpj_limpo = limpa_cpf_cnpj(cpf_cnpj);

    try {
      if (cpf_cnpj_limpo.length == 11 || cpf_cnpj_limpo.length < 11) {
        if (!validateCPF(cpf_cnpj_limpo)) {
          setError("O CPF digitado é inválido!");
          setErrorTitle("CPF inválido");

          return;
        }
      }

      if (senha.length == 0) {
        setError("O campo senha não pode ser vázio!");
        setErrorTitle("Senha inválida!");
        return;
      }
      const { data } = await api.get(
        `/funcionario-prefeitura/por-cpf/${cpf_cnpj_limpo}`
      );
      if(data.length > 0){
          setFuncionariosByCpfList(data);
          setOpenModalList(true)
      }else{
          throw new Error("Dados de acesso estao incorretors!");
      }
    } catch (error) {
      setError(
        `Sua combinação de 
         "CPF"
         e senha estão incorretos!  `
      );
      setErrorTitle("Dados de login inválidos!");
    } finally {
      setLoading(false);
    }
  }

  return (
    <SignIn
      children={
        <>
          <InputContainer>
            <LoginInputs
              placeholder="CPF"
              type="cpf"
              execute={handleCPF_CNPJ}
              value={cpf_cnpj}
            />
          </InputContainer>
          <InputContainer>
            <LoginInputs
              placeholder="SENHA"
              type="pass"
              execute={handleSenha}
              value={senha}
            />
          </InputContainer>

          <InputButton>
            <SignInButton
              text="LOGIN"
              enable={false}
              type={"login"}
              execute={handleSignIn}
              loading={loading}
            />
          </InputButton>
        

          <HelperSpan>
            <RememberPassword type="Funcionario-Prefeitura" />
          </HelperSpan>
          <Alert
            message={error}
            onClose={() => {
              setError("");
            }}
            open={error.length > 0}
            title={errorTitle}
          />

          <ListFuncionariosModal open={openModalList} onClose={()=>{setOpenModalList(false)}} data={funcionariosByCpfList} senha={senha}/>
        </>
      }
    />
  );
}
